import React from "react";
import { Helmet } from "react-helmet";

const MyPage = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default MyPage;
